<script>
/**
 * Usage:
 * <editable-list-cell data=[1,2,3] width="50" pattern="/^\d+$/" tips="Please input digitals." change=function/>
 */
const props = {
  data: {
    type: Array,
    required: true
  },
  width: {
    type: [Number, String], //unit is percend
    default: ""
  },
  pattern: {
    type: String, //regexp
    required: true
  },
  change: {
    type: Function, //()=>void
    required: true
  },
  tips: {
    type: String,
    default: ""
  },
  editable: {
    type: Boolean,
    default: true
  }
};
const methods = {
  changeHanlder(newData, isSave) {
    if (isSave) {
      this.newData = newData.split(",").filter(d => d != "");
    }
  },
  deleteDataAt(index) {
    let yes = confirm("Are Your sure to delet?");
    if (yes) {
      let o = this.newData.filter((d, i) => i != index).join(",");
      return this.change(o).then(this.changeHanlder.bind(this, o));
    }
  },
  adding() {
    this.addItem = "";
  },
  add() {
    let dataOK = this.addItem != null && this.p.test(this.addItem);
    let z = new Set([...this.newData]);
    if (dataOK && !z.has(this.addItem)) {
      z.add(this.addItem);
      let newData = [...z].filter(d => d != "").join(",");
      this.change(newData).then(this.changeHanlder.bind(this, newData));
    } else {
      let formatTip = this.tips || `Input should match /${this.pattern}/`;
      if (!dataOK) {
        alert(formatTip);
      }
    }
    this.addItem = null;
  }
};
function data() {
  return {
    newData: this.data,
    addItem: null,
    p: new RegExp(this.pattern)
  };
}
export default {
  props,
  methods,
  data
};
</script>

<template>
  <td :width="`${width}%`">
    <div class="root">
      <div
        v-for="(d,i) in newData"
        :key="i"
        @click="editable? deleteDataAt(i): void ''"
        cell-type="list"
        :title="editable? `Click to Delete value: ${d}`:''"
        :class="editable?'data':''"
      >{{d}}</div>
      <div
        v-if="addItem == null && editable"
        title="add a new data"
        @click="adding"
        class="plus"
        key="plus"
      >+</div>
      <div class="adding" v-else-if="editable" key="adding">
        <input pattern="pattern" :placeholder="tips||`/${pattern}/`" v-model.lazy="addItem">
        <div class="save" @click="add">Save</div>
      </div>
    </div>
  </td>
</template>
<style scoped>
.root {
  flex: 1;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: row wrap;
}
input {
  flex: 7;
}
.data {
  flex: 1;
  background: aquamarine;
  border-radius: 1ex;
  border: 0 1ex;
  min-width: 3ex;
  justify-content: center;
}
.plus {
  flex: 0;
  min-width: 3ex;
  min-height: 2ex;
  background: gray;
  justify-content: center;
  align-items: center;
}
.adding {
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
}
.save {
  border-radius: 1ex;
}
</style>




// WEBPACK FOOTER //
// EditableListCell.vue?46739574